import { SeverityType } from '../constant/index';
// limit the auto reported error repeat time (actively reported error will not be limited)
export const errorLogLimitPipe = (airTracker) => {
    const errorLogMap = {};
    return (logs, resolve) => {
        const maxNum = typeof airTracker.config.errorRepeatTime === 'number' ? airTracker.config.errorRepeatTime : 5;
        if (maxNum === 0) {
            return resolve === null || resolve === void 0 ? void 0 : resolve(logs);
        }
        resolve === null || resolve === void 0 ? void 0 : resolve(logs.filter((log) => {
            // only limit the AUTO_DETECT_ERROR
            if (log.severity == SeverityType.AUTO_DETECT_ERROR) {
                errorLogMap[log.error] = errorLogMap[log.error] || 0;
                errorLogMap[log.error] += 1;
                if (errorLogMap[log.error] > maxNum) {
                    return false;
                }
                return true;
            }
            return true;
        }));
    };
};
